export function getCSRFToken() {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, 10) === 'csrftoken=') {
                cookieValue = decodeURIComponent(cookie.substring(10));
                break;
            }
        }
    }
    return cookieValue;
}

// Fetch a CSRF token from the backend and return it. This also causes Django
// to set the csrftoken cookie via Set-Cookie in the response.
export async function fetchCSRFToken(baseURL = '') {
    try {
        const url = baseURL ? `${baseURL}/api/csrf/` : '/api/csrf/';
        const res = await fetch(url, { credentials: 'include' });
        if (!res.ok) throw new Error(`Failed to fetch CSRF: ${res.status}`);
        const data = await res.json();
        // Prefer token from response if provided; otherwise read from cookie.
        const token = data?.csrfToken || getCSRFToken();
        return token || null;
    } catch (e) {
        console.error('Error fetching CSRF token:', e);
        return null;
    }
}
